module.exports = __webpack_public_path__ + "static/img/case3.d38025c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/h5/case3.png
// module id = m2jo
// module chunks = 34